module.exports = __webpack_public_path__ + "static/img/ES.0d1ede6a.png";